module.exports = __webpack_public_path__ + "img/vision2.63432db7.svg";